export default __webpack_public_path__ + "static/MaisonNeue-Medium-61bb63eb2796266018001b2e39e76c65.woff2";